import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Previsions from "../pages/Previsions/index";
import Occupation from "../pages/Occupation/index";
import GrillesAVT from "../pages/GrillesAVT/index";
import Hotels from "../pages/Hotels/index";
import Contacts from "../pages/Contacts/index";
import Traffic from "../pages/Traffic/index";
import PrivateRoute from "./PrivateRoute";
import { AuthProvider } from "../context/authContext";
import Layout from "../components/common/Layout";
import RoleRoute from "./RoleRoute";
import Forbidden from "../pages/Forbidden";
import { Login } from "../pages/Login";

export const protectedRoutes = [
  { path: "/previsions", element: <Previsions /> },
  { path: "/occupation", element: <Occupation /> },
  { path: "/achalandage", element: <Traffic />, roles: ["Admin", "Manager"] },
  { path: "/grilles-avt", element: <GrillesAVT />, roles: ["Admin"] },
  { path: "/ajout-hotel", element: <Hotels />, roles: ["Admin"] },
  { path: "/contacts", element: <Contacts />, roles: ["Admin"] },
  { path: "/forbidden", element: <Forbidden /> },
];

/**
 * Main routing component for the application.
 * Provides routing structure, authentication protection, and layout configuration.
 */
export const AppRoutes = (): React.JSX.Element => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              {protectedRoutes.map(({ path, element, roles }) => {
                if (!roles) {
                  return <Route key={path} path={path} element={element} />;
                }

                return (
                  <Route
                    key={path}
                    element={<RoleRoute allowedRoles={roles} />}
                  >
                    <Route path={path} element={element} />
                  </Route>
                );
              })}
            </Route>
          </Route>
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default AppRoutes;
